import React from 'react';
import { handleActions } from 'redux-actions';
import { destoryLoadingFunc, createLoadingFunc } from 'pub-comp/loading';
import actions from './actions';
const defaultState = {
  currLan: window.getCurrentLangCode && window.getCurrentLangCode() || 'zh_CN',//当前的语言
};
const {
	requestStart,
	requestSuccess,
  requestError,
  applyService,
  getCurrentNot,
  setCurrentNot,
} = actions
const reducer = handleActions({
	[requestStart](state) {
		createLoadingFunc({ text: lang.template("P_YS_FED_EXAMP_0000020391") /* "加载中..." */ });
		return state;
	},
	[requestSuccess](state) {
		destoryLoadingFunc();
		return state;
	},
	[requestError](state, { payload: msg }) {
		destoryLoadingFunc();
		if (typeof msg !== "string") {
			console.log(msg);
			return {
				...state
			}
		}
		return {
			...state,
			showModal: true,
			dialogData: {
				type: 'error',//'error',
				title: lang.template("P_YS_FI_CM_0000029607") /* "错误" */,
				msg
			},
		};
  },
  [applyService]: state => ({
    ...state,
  }),
  [getCurrentNot]: (state, { payload }) => {
		// console.log('payload',payload.langCode)
		return {
			...state,
			currLan: payload.langCode
		}
  },
  [setCurrentNot]: state => state,
}, defaultState);
export default reducer